import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import "./assets/index.css";

import Layout from "./pages/Layout";
import Home from "./pages/Home";
import ViewObject from "./pages/ViewObject";
import NoPage from "./pages/NoPage";

export default function App() {
  useEffect(() => {
    const handleContentHeightChange = () => {
      const contentHeight = document.body.scrollHeight;

      if (window.parent !== window) {
        window.parent.postMessage(
          { height: contentHeight },
          window.location.origin
        );
      }
    };

    const interval = setInterval(
      handleContentHeightChange,
      1000
    );

    return () => {
      clearInterval(interval);
    };
  }, []);

  const basename =
    process.env.REACT_APP_BASENAME || "/app";

  return (
    <HelmetProvider>
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route
              path="object/:id"
              element={<ViewObject />}
            />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}
